module.exports = __webpack_public_path__ + "img/logo_mensagem_agradecimento.0288518a.png";